import { forwardRef, type Ref, type SVGProps } from "react";

function SvgGiftLavenderColored(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 50 50" {...props}>
      <rect
        width={46}
        height={46}
        x={2}
        y={2}
        stroke="url(#gift_lavender_colored_svg)"
        strokeWidth={4}
        rx={23}
      />
      <path
        stroke="#0C1C43"
        strokeLinejoin="round"
        d="M25 21.143v-1.714m0 1.714h-1.818c-2.008 0-3.636-1.535-3.636-3.429 0-.947.814-1.714 1.818-1.714C23.372 16 25 17.535 25 19.429m0 1.714h1.818c2.008 0 3.636-1.535 3.636-3.429 0-.947-.814-1.714-1.818-1.714C26.628 16 25 17.535 25 19.429m0 1.714h-6.818c-1.205 0-2.182.92-2.182 2.057v.257c0 .762.439 1.426 1.09 1.782M25 21.143h6.818c1.205 0 2.182.92 2.182 2.057v.257c0 .762-.439 1.426-1.09 1.782M25 21.143v4.371M25 34h-5.727c-1.205 0-2.182-.921-2.182-2.057v-6.704M25 34h5.727c1.205 0 2.182-.921 2.182-2.057v-6.704M25 34v-8.486m0 0h6.818c.398 0 .77-.1 1.091-.275M25 25.514h-6.818c-.398 0-.77-.1-1.091-.275m0-.239v.24m15.818 0V25"
      />
      <defs>
        <linearGradient
          id="gift_lavender_colored_svg"
          x1={25}
          x2={25}
          y1={0}
          y2={50}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.195} stopColor="#DBD8FE" />
          <stop offset={1} stopColor="#F6F3F1" />
        </linearGradient>
      </defs>
    </svg>
  );
}
const ForwardRef = forwardRef(SvgGiftLavenderColored);
export default ForwardRef;
